export const AUDIO_REPEATED_NOTE_MIN_INTERVAL_MS = 180;

const normalizeMidiNotes = (notes: number[] | undefined) =>
  Array.from(new Set((notes ?? []).map((note) => Math.round(note)))).filter(
    (note) => note >= 0 && note <= 127,
  );

export const getRepeatedNoteRetriggers = (
  onsetMidiNotes: number[] | undefined,
  detectedNotes: ReadonlySet<number>,
  activeNotes: ReadonlySet<number>,
  activeSinceMs: ReadonlyMap<number, number>,
  nowMs: number,
  minIntervalMs = AUDIO_REPEATED_NOTE_MIN_INTERVAL_MS,
) =>
  normalizeMidiNotes(onsetMidiNotes).filter((note) => {
    if (!detectedNotes.has(note) || !activeNotes.has(note)) return false;
    const activeSince = activeSinceMs.get(note);
    return activeSince != null && nowMs - activeSince >= minIntervalMs;
  });
